import { get } from './api-client';

export const newsletterService = {
    subscribeNewsletter: (data) => get('/Newsletter/SubscribeNewsletter', data)
};